import { createFileRoute } from '@tanstack/react-router';
import { UnitsProvider, UnitsView } from '@ludolio/shared-units';
import { useTeacherUnitsModule } from '@/units/teacherUnitsModule';

export const Route = createFileRoute('/_authenticated/units/')({
  component: UnitsPage,
});

function UnitsPage() {
  const module = useTeacherUnitsModule();
  return (
    <UnitsProvider module={module}>
      <UnitsView />
    </UnitsProvider>
  );
}

